import { render, staticRenderFns } from "./RepoTable.vue?vue&type=template&id=71cd6cf6&scoped=true&"
import script from "./RepoTable.vue?vue&type=script&lang=js&"
export * from "./RepoTable.vue?vue&type=script&lang=js&"
import style0 from "./RepoTable.vue?vue&type=style&index=0&id=71cd6cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cd6cf6",
  null
  
)

export default component.exports